export default {
  landingNoProductFiltersTitle: {
    id: 'landing_no_product_filters_title',
    defaultMessage: 'Product not found.',
  },
  landingNoProductFiltersDescription: {
    id: 'landing_no_product_filters_description',
    defaultMessage:
      'We have looked everywhere: the product you are looking for does not exist on our platform. Why not try your luck with another search or keyword?',
  },
}
